"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PUT_SCROLL_GROUP = exports.CALL_SCROLL_GROUP = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./OptionChain.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CALL_SCROLL_GROUP = 'call';
exports.CALL_SCROLL_GROUP = CALL_SCROLL_GROUP;
const PUT_SCROLL_GROUP = 'put';
/**
 * Buttons allow users to take actions, and make choices, with a single tap.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */

exports.PUT_SCROLL_GROUP = PUT_SCROLL_GROUP;

const OptionChain = ({
  calls = [],
  inCalls = [],
  inPuts = [],
  inStrikes = [],
  onLoadMore,
  puts = [],
  showAsk = true,
  showBid = true,
  showIV = true,
  showLTP = true,
  showLegend = false,
  showLoadMore = false,
  showOI = true,
  showVolume = true,
  showChart = true,
  spotPrice = '--',
  strikes = [],
  rightTableLegend = 'Puts'
}) => {
  const scrollCallRef = React.useRef(null);
  const scrollPutRef = React.useRef(null);
  const callRef = React.useRef(null);
  const putRef = React.useRef(null);
  const callContainerRef = React.useRef(null);
  const middleContainerRef = React.useRef(null);
  const [callScrollOffset, setCallScrollOffset] = React.useState(0);
  const [callScrolledLeft, setCallScrolledLeft] = React.useState(false);
  const [callScrolledRight, setCallScrolledRight] = React.useState(true);
  const [putScrollOffset, setPutScrollOffset] = React.useState(0);
  const [putScrolledLeft, setPutScrolledLeft] = React.useState(true);
  const [putScrolledRight, setPutScrolledRight] = React.useState(false);
  const [callContainerWidth, setCallContainerWidth] = React.useState(0);
  const [middleContainerWidth, setMiddleContainerWidth] = React.useState(0);
  const [scrollSource, setScrollSource] = React.useState('table');
  const [wheelDeltaX, setWheelDeltaX] = React.useState(0);
  const columnProps = {
    showAsk,
    showBid,
    showIV,
    showLTP,
    showOI,
    showVolume,
    showChart
  };
  React.useEffect(() => {
    if (callContainerRef.current) {
      const {
        width
      } = callContainerRef.current.getBoundingClientRect();
      setCallContainerWidth(width);
    }

    if (middleContainerRef.current) {
      const {
        width
      } = middleContainerRef.current.getBoundingClientRect();
      setMiddleContainerWidth(width);
    }
  }, []);

  const handleKeyPress = event => {
    if (event.shiftKey) {
      setWheelDeltaX(event.deltaX / 30);
    } else {
      setWheelDeltaX(0);
    }
  };

  const hoverCallPosition = () => {
    if (callRef.current) {
      const {
        width
      } = callRef.current.getBoundingClientRect();
      const {
        scrollLeft
      } = callRef.current;
      const {
        scrollWidth
      } = callRef.current;
      setCallScrollOffset(Math.round(scrollWidth - width - scrollLeft));
      setCallScrolledLeft(scrollLeft > 0);
      setCallScrolledRight(scrollLeft + Math.round(width) < scrollWidth);
    }
  };

  const hoverPutPosition = () => {
    if (putRef.current) {
      const {
        width
      } = putRef.current.getBoundingClientRect();
      const {
        scrollLeft
      } = putRef.current;
      const {
        scrollWidth
      } = putRef.current;
      setPutScrollOffset(Math.round(scrollLeft));
      setPutScrolledLeft(scrollLeft > 0);
      setPutScrolledRight(scrollLeft + Math.round(width) < scrollWidth);
    }
  };

  const handleCallScroll = () => {
    if (scrollSource === 'header') {
      if (scrollCallRef.current && scrollPutRef.current && callRef.current) {
        const percentagePerWidth = scrollCallRef.current.scrollLeft / (scrollCallRef.current.scrollWidth - scrollCallRef.current.offsetWidth);
        scrollPutRef.current.scrollLeft = scrollPutRef.current.offsetWidth - scrollCallRef.current.scrollLeft;
        callRef.current.scrollLeft = Math.round(percentagePerWidth * (callRef.current.scrollWidth - callRef.current.offsetWidth));
      }
    }
  };

  const handlePutScroll = () => {
    if (scrollSource === 'header') {
      if (scrollPutRef.current && scrollCallRef.current && putRef.current) {
        const percentagePerWidth = scrollPutRef.current.scrollLeft / (scrollPutRef.current.scrollWidth - scrollPutRef.current.offsetWidth);
        scrollCallRef.current.scrollLeft = scrollPutRef.current.offsetWidth - scrollPutRef.current.scrollLeft;
        putRef.current.scrollLeft = Math.round(percentagePerWidth * (putRef.current.scrollWidth - putRef.current.offsetWidth));
      }
    }
  };

  const callScroll = () => {
    if (scrollSource === 'table') {
      if (callRef.current && putRef.current && scrollCallRef.current) {
        const percentagePerWidth = callRef.current.scrollLeft / (callRef.current.scrollWidth - callRef.current.offsetWidth);
        putRef.current.scrollLeft = Math.round((1 - percentagePerWidth) * (putRef.current.scrollWidth - putRef.current.offsetWidth - wheelDeltaX));
        scrollCallRef.current.scrollLeft = Math.round(percentagePerWidth * (scrollCallRef.current.scrollWidth - scrollCallRef.current.offsetWidth + wheelDeltaX));
      }
    }
  };

  const putScroll = () => {
    if (scrollSource === 'table') {
      if (putRef.current && callRef.current && scrollPutRef.current) {
        const percentagePerWidth = putRef.current.scrollLeft / (putRef.current.scrollWidth - putRef.current.offsetWidth);
        callRef.current.scrollLeft = Math.round((1 - percentagePerWidth) * (callRef.current.scrollWidth - callRef.current.offsetWidth + wheelDeltaX));
        scrollPutRef.current.scrollLeft = Math.round(percentagePerWidth * (scrollPutRef.current.scrollWidth - scrollPutRef.current.offsetWidth - wheelDeltaX));
      }
    }
  };

  React.useLayoutEffect(() => {
    if (scrollCallRef.current && scrollPutRef.current && callContainerRef.current) {
      scrollCallRef.current.addEventListener('scroll', (0, _debounce.default)(hoverCallPosition, 80));
      scrollPutRef.current.addEventListener('scroll', (0, _debounce.default)(hoverPutPosition, 80));
      callContainerRef.current.addEventListener('wheel', handleKeyPress);
    }
  }, []);
  return (0, _pragma.createFelaElement)(_.View, {
    css: css.root
  }, (0, _pragma.createFelaElement)(_.OptionChainCallTable, {
    handleCallScroll: handleCallScroll,
    scrollCallRef: scrollCallRef,
    callScrolledLeft: callScrolledLeft,
    callScrolledRight: callScrolledRight,
    strikeCalls: inCalls,
    spotCalls: calls,
    callRef: callRef,
    callScrollOffset: callScrollOffset,
    hoverCallPosition: hoverCallPosition,
    showLegend: showLegend,
    callContainerRef: callContainerRef,
    columnProps: columnProps,
    callScroll: callScroll,
    setScrollSource: setScrollSource,
    scrollSource: scrollSource
  }), (0, _pragma.createFelaElement)(_.OptionChainMiddleTable, {
    strikes: inStrikes,
    spotPrice: spotPrice,
    spots: strikes,
    callContainerWidth: callContainerWidth,
    middleContainerWidth: middleContainerWidth,
    showLegend: showLegend,
    middleContainerRef: middleContainerRef
  }), (0, _pragma.createFelaElement)(_.OptionChainPutTable, {
    handlePutScroll: handlePutScroll,
    scrollPutRef: scrollPutRef,
    putScrolledLeft: putScrolledLeft,
    putScrolledRight: putScrolledRight,
    spotPuts: inPuts,
    strikePuts: puts,
    putRef: putRef,
    putScrollOffset: putScrollOffset,
    hoverPutPosition: hoverPutPosition,
    showLegend: showLegend,
    columnProps: columnProps,
    rightTableLegend: rightTableLegend,
    putScroll: putScroll,
    setScrollSource: setScrollSource,
    scrollSource: scrollSource
  }), showLoadMore && (0, _pragma.createFelaElement)(_.Button, {
    css: css.loadMoreButton,
    onClick: onLoadMore,
    size: "small",
    variant: "secondary"
  }, (0, _pragma.createFelaElement)(_.View, {
    gap: "xsmall",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.RefreshIcon, {
    size: "small"
  }), (0, _pragma.createFelaElement)("span", null, "Load More"))));
};

OptionChain.displayName = 'OptionChain';
var _default = OptionChain;
exports.default = _default;
//# sourceMappingURL=OptionChain.js.map